export const CandidatePreferenceUpdateMode = Object.freeze({
  None: 0,
  Locations: 1,
})
